export function clamp(value, low, high) {
	low = low !== undefined ? low : Number.MIN_SAFE_INTEGER;
	high = high !== undefined ? high : Number.MAX_SAFE_INTEGER;
	if (value < low) {
		value = low;
	}
	if (value > high) {
		value = high;
	}
	return value;
}
export function degreesToRadians(degrees) {
	return (degrees * Math.PI) / 180;
}
export function radiansToDegrees(radians) {
	return (radians * 180) / Math.PI;
}
export function getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min) + min);
}
export function getRandomBoolean() {
	return Math.random() < 0.5;
}
export function roundToNearest(value, nearest) {
	return Math.round(value / nearest) * nearest;
}